import { useMutation } from 'react-query';
import request from '../../../../../../helpers/request';
import { useDispatch } from 'react-redux';
import { fetchShutdownsThunk } from '../../../../shared/model/actions';

const changeDescription = async ({ shutdownId, data }) => {
  const res = await request.put(
    `/Alert/description/${shutdownId}`,
    data,
    'Не удалось сохранить описание',
    'Error'
  );

  return res;
};

export const useShutdownDescChange = (options = {}) => {
  const dispatch = useDispatch();

  const changeMutation = useMutation(changeDescription, {
    ...options,
    onSuccess: (res, { shutdownId, data }) => {
      if (res !== 'Error') {
        dispatch(fetchShutdownsThunk());
      }
    },
  });

  return {
    change: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
